import ReviewSearch from './inc/ReviewSearch';

if (document.querySelector('#review-loadmore-holder') !== null)
	new ReviewSearch();
